import { Injector } from '@angular/core';
import { createNodeFromContent, DOMNode, mergeAttributes, Node } from '@tiptap/core';
import { Fragment } from '@tiptap/pm/model';
import { AngularNodeViewRenderer } from 'ngx-tiptap';
import { KeyPointCalloutComponent } from './key-point-callout.component';
import { DEFAULT_KEY_POINT_CALLOUT_PROPS } from './key-point-callout.model';

const keyPointCalloutClassName = 'key-point-callout';

export const KeyPointCalloutExtension = (injector: Injector) => {
  return Node.create({
    name: 'keyPointCallout',
    content: 'block+',
    group: 'block',
    defining: true,
    selectable: true,
    draggable: true,

    addAttributes() {
      return {
        title: {
          default: DEFAULT_KEY_POINT_CALLOUT_PROPS.title,
        },
        color: {
          default: DEFAULT_KEY_POINT_CALLOUT_PROPS.color,
        },
        icon: {
          default: DEFAULT_KEY_POINT_CALLOUT_PROPS.icon,
        },
        custom_css: {
          default: '',
        },
        class: {
          renderHTML: (attributes) => {
            const otherClasses = ((attributes['class'] ?? '') as string)
              .split(' ')
              .filter((c) => c !== keyPointCalloutClassName);
            return { class: `${keyPointCalloutClassName} ${otherClasses.join(' ')}` };
          },
        },
      };
    },

    parseHTML() {
      return [
        {
          tag: `div.${keyPointCalloutClassName}`,
          getContent(node: DOMNode, schema) {
            if (!(node instanceof Element)) {
              return Fragment.from(createNodeFromContent(node.textContent, schema));
            }

            const contentElement = node.querySelector('.key-point-callout-content');

            const htmlContent = contentElement ? contentElement.innerHTML : node.innerHTML;

            return Fragment.from(createNodeFromContent(htmlContent, schema));
          },
        },
      ];
    },

    renderHTML({ HTMLAttributes }) {
      return ['div', mergeAttributes({ class: keyPointCalloutClassName }, HTMLAttributes), 0];
    },

    addNodeView() {
      return AngularNodeViewRenderer(KeyPointCalloutComponent, { injector });
    },
  });
};
